import { render, staticRenderFns } from "./FixedSideMenu.vue?vue&type=template&id=a4171188&scoped=true"
import script from "./FixedSideMenu.vue?vue&type=script&lang=ts"
export * from "./FixedSideMenu.vue?vue&type=script&lang=ts"
import style0 from "./FixedSideMenu.vue?vue&type=style&index=0&id=a4171188&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4171188",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4171188')) {
      api.createRecord('a4171188', component.options)
    } else {
      api.reload('a4171188', component.options)
    }
    module.hot.accept("./FixedSideMenu.vue?vue&type=template&id=a4171188&scoped=true", function () {
      api.rerender('a4171188', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/FixedSideMenu.vue"
export default component.exports